var _defs, _path, _path2, _polygon, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 284.08 94.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 111.97,
    y1: 7.99,
    x2: 137.77,
    y2: 7.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2957d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 68.78,
    y1: 54.65,
    x2: 129.98,
    y2: 54.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 45.94,
    y1: 63.09,
    x2: 66.91,
    y2: 63.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 27.02,
    y1: 63.22,
    x2: 52.99,
    y2: 63.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 8.75,
    y1: 70.5,
    x2: 44.69,
    y2: 70.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 107.05,
    y1: 78.84,
    x2: 129.99,
    y2: 78.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e94d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 131.31,
    y1: 78.44,
    x2: 170.77,
    y2: 78.44,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 171.83,
    y1: 78.02,
    x2: 192.14,
    y2: 78.02,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 193.2,
    y1: 77.81,
    x2: 216.99,
    y2: 77.81,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 218.05,
    y1: 78.21,
    x2: 226.8,
    y2: 78.21,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 227.87,
    y1: 77.47,
    x2: 250.78,
    y2: 77.47,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 251.85,
    y1: 77.37,
    x2: 272.11,
    y2: 77.37,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 268.07,
    y1: 56.6,
    x2: 282.58,
    y2: 56.6,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 280.91,
    y1: 60.04,
    x2: 292.82,
    y2: 60.04,
    xlinkHref: "#linear-gradient-6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.63,2.4a3.87,3.87,0,0,0-1-.25s0,0,0,0,0,0,0,0h-.15c-.4,0-.26-.06-.91-.13a2.32,2.32,0,0,0-1.33.27c-.27.12-6.1,3.15-6.1,3.15-.32-.29-.67-.07-.89,0s-.21,0-.26,0a1,1,0,0,0-.32.12.09.09,0,0,0,0,.11c-.13.07-.82.37-.88.39s-1.53-.3-1.67-.34l-5.52-1.28c-.15-.05-.61,0-.82,0a4.05,4.05,0,0,1-.76-.42.39.39,0,0,0-.34-.08c-.07,0,0,.05,0,.13s.8.75,1,.85,2.07.89,2.07.89l.17-.07-.3.32.7.3,0,0a3.3,3.3,0,0,0-.22.32c0,.07-.08.22,0,.19a5.65,5.65,0,0,0,.58-.34l1.53.67-.18.3a.13.13,0,0,0,0,.18,3,3,0,0,0,.54-.3,1.43,1.43,0,0,0,.24.12.82.82,0,0,1,.35.27c.08.1,0,.09,0,.09l-4.32,2.23s-1.15.12-1.2.11a5.67,5.67,0,0,1-.63-.36c-.21-.13-1.88-1.06-2-1.08a5.24,5.24,0,0,0-.85.4l.94,2s-2.11-.35-2.44-.42a1.07,1.07,0,0,0-.69.14C112,11,112,11,112,11l3.23,1.39s-.63.49-.69.52a.15.15,0,0,0,0,.19.85.85,0,0,0,.58,0l1-.18,1.23,1s.15,0,.37-.13.14-.18.14-.3,0-1,0-1.05,1-.29,2.43-.7a16.48,16.48,0,0,0,2.31-.9c0,.06,0,.13-.06.17s0,0,0,0,.06-.16.09-.24l.5-.24a3,3,0,0,1,1.33-.43,16.09,16.09,0,0,0,1.62-.34.9.9,0,0,1-.1.18c-.06.07-.1.15,0,.15s.17-.14.17-.14l.6.21s0,0,0,.07,0,.09.08,0,0,.1,0,.15-.09.16,0,.21.1,0,.22-.1l.39-.32.27.35a1.11,1.11,0,0,1-.08.24c-.06.14-.11.27,0,.22a1,1,0,0,0,.29-.17s.4.46.41.48-.13.28-.17.36,0,.18.18.07a2.16,2.16,0,0,0,.41-.3s.39.43.45.48a.23.23,0,0,1,.08.2c0,.07,0,.07.1,0a.91.91,0,0,1,.31-.12.91.91,0,0,0,.49-.26c.12-.14.17-.07.23,0s.07,0,.07,0L130,9.73h.06c.09,0-.07,0,0,.06a2,2,0,0,0,.74-.17,4.22,4.22,0,0,0,1.09-.56c.25-.17.41-.44.07-.93s-.58-.35-.92-.25a8.35,8.35,0,0,0-1.1.52,1.31,1.31,0,0,1-.22.1L129.61,8a.12.12,0,0,1,0-.16l.42-.34c.25-.2.47-.46.62-.6a2.3,2.3,0,0,1,.31-.24c.19-.11,3-1.53,3.79-1.93a13.51,13.51,0,0,0,2.47-1.49l.16-.14c0,.05,0,.1,0,.07a.25.25,0,0,0,0-.09C137.92,2.66,137.77,2.49,137.63,2.4ZM119.87,9.88v.06a.09.09,0,0,1-.09.08.07.07,0,0,1-.09-.07v0a.09.09,0,0,1,.08-.09A.08.08,0,0,1,119.87,9.88Zm.49-.25v.06a.11.11,0,0,1-.09.09.08.08,0,0,1-.09-.07V9.65a.09.09,0,0,1,.08-.09S120.36,9.59,120.36,9.63Zm.49-.25v.06s0,.08-.08.09a.08.08,0,0,1-.09-.07V9.4a.09.09,0,0,1,.08-.09S120.85,9.34,120.85,9.38Zm.49-.24v0a.08.08,0,0,1-.08.09.08.08,0,0,1-.09-.07V9.15a.09.09,0,0,1,.18,0Zm.49-.25V9s0,.08-.08.08a.09.09,0,0,1-.1-.07V8.9a.09.09,0,0,1,.18,0Zm.49-.25V8.7s0,.08-.08.08a.08.08,0,0,1-.1-.07V8.66a.08.08,0,0,1,.08-.09A.1.1,0,0,1,122.32,8.64Zm.49-.25v.06s0,.08-.08.09a.1.1,0,0,1-.1-.07V8.41c0-.05,0-.08.08-.09A.1.1,0,0,1,122.81,8.39Zm.49-.25V8.2s0,.08-.08.09a.1.1,0,0,1-.1-.07V8.16s0-.08.08-.09A.1.1,0,0,1,123.3,8.14Zm5-1.81c-.1,0-.29-.12-.43-.39s-.16-.51-.05-.57.29.12.42.39S128.43,6.27,128.33,6.33Zm.18-.84v.06a.1.1,0,0,1-.08.09c-.05,0-.1,0-.1-.07V5.51s0-.08.08-.09A.08.08,0,0,1,128.51,5.49Zm3,2.38c.11-.06.31.1.46.35s.18.51.08.57-.31-.09-.46-.35S131.44,7.93,131.54,7.87Zm-1.34,3.81s0,.05-.06,0v-.08h.05Zm0-.16h0c0-.1-.06-.25-.09-.41l.06,0Zm-.09-.47H130l-.09-.42H130Zm-.1-.48-.06,0-.09-.43h.06Zm-.1-.47h-.06l-.06-.33h.05ZM129,5.22v.06a.11.11,0,0,1-.08.09.09.09,0,0,1-.1-.08v0s0-.08.08-.09A.08.08,0,0,1,129,5.22Zm.52-.27V5a.09.09,0,0,1-.08.08.08.08,0,0,1-.1-.07V5s0-.08.08-.08A.08.08,0,0,1,129.55,5Zm.52-.27v.06a.09.09,0,0,1-.08.08.08.08,0,0,1-.1-.07V4.69s0-.08.08-.08A.07.07,0,0,1,130.07,4.68Zm.52-.27v.06a.08.08,0,0,1-.08.08c-.05,0-.1,0-.1-.07V4.42s0-.08.08-.08A.07.07,0,0,1,130.59,4.41Zm.53-.27v.05a.09.09,0,0,1-.08.09s-.1,0-.1-.07V4.15s0-.08.08-.09A.1.1,0,0,1,131.12,4.14Zm.52-.28v.06a.09.09,0,0,1-.08.09c-.05,0-.1,0-.1-.07V3.88s0-.08.08-.09A.1.1,0,0,1,131.64,3.86Zm.52-.27v.06a.09.09,0,0,1-.18,0V3.61a.08.08,0,0,1,.08-.09A.1.1,0,0,1,132.16,3.59Zm.52-.27v.06a.08.08,0,0,1-.08.08.08.08,0,0,1-.1-.07V3.33s0-.08.08-.08A.1.1,0,0,1,132.68,3.32Zm2.57-1.07a1.75,1.75,0,0,0-.32.12c-.09,0-.07,0-.07,0V2.14a3.33,3.33,0,0,1,.39-.11.31.31,0,0,1,.22.11S135.27,2.24,135.25,2.25Zm.6-.17a.5.5,0,0,1-.15,0,1,1,0,0,1-.28-.1s.08,0,.17,0Z",
    transform: "translate(-8.75 -1.99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.75,28.17,130,13.2,112.17,50.87,91,96.1H68.78l13.6-44.69,4.31-16.08s.81-2.95-.87-4.45a7.23,7.23,0,0,0-2.37-1.38Z",
    transform: "translate(-8.75 -1.99)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "60.03 94.11 59.79 93.63 45.94 66.23 52.99 32.08 66.91 61.44 60.03 94.11"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "35.94 94.37 52.99 32.08 30.64 39.95 27.02 60.53 35.94 94.37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.75,51.09,30.66,96.63l14-.27L36.1,72.11,29.29,53.75a15,15,0,0,0-1.17-2.5c-.63-1-1.25-3.44,2.64-6.89l-22,6.51",
    transform: "translate(-8.75 -1.99)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.52,95.88a10.16,10.16,0,0,1-8.09-4.13q-3.37-4.11-3.38-11.19,0-8.85,3.41-13.81t8.06-4.94c3.11,0,5.81,1.65,8.07,4.94s3.4,7.91,3.4,13.81q0,7.08-3.38,11.19A10.16,10.16,0,0,1,118.52,95.88Zm.64-8.82a4.66,4.66,0,0,0,4-2.29q1.58-2.3,1.57-7.1a9.35,9.35,0,0,0-1.57-5.42,4.53,4.53,0,0,0-7.9,0,9.35,9.35,0,0,0-1.58,5.42q0,4.8,1.58,7.1A4.64,4.64,0,0,0,119.16,87.06Z",
    transform: "translate(-8.75 -1.99)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141.29,94.75l-10-26.27,7.62-5.7L144,80.92l6.9-14.5,7.37,14,3.95-18.25,8.52,6.23L161,93.52l-6.92-2L151.17,79l-3.83,14.68Z",
    transform: "translate(-8.75 -1.99)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M177.21,94.11l1.57-23.23-6.95-.6.51-7.2,19.12-1.15L192.14,72l-7.43-.78L185.53,92Z",
    transform: "translate(-8.75 -1.99)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M209.77,94l-8.52-12.56L201.78,92l-8.58,1.21,1.93-31.57q21.08,1.56,21.8,10c0,.46.06,1.24.06,2.33,0,4.27-2.59,7.25-7.77,9l6.84,5.56Zm-8.9-17.25q9.36,0,9.37-4.84,0-2.75-9.58-4.06Z",
    transform: "translate(-8.75 -1.99)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M218.05,94.94,218.48,62l6.6-.53,1.72,31.79Z",
    transform: "translate(-8.75 -1.99)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M229.52,93.86l-1.65-31.67a57.81,57.81,0,0,1,9.3-.79,23.29,23.29,0,0,1,3.63-.32q9.25,0,10,9.8,0,9.57-13.23,9.57h-1.32l1.39,11.81Zm5.27-19.2q9.51,0,9.52-4.32l0-.27a3.51,3.51,0,0,0-3.92-3.59,43.17,43.17,0,0,0-6.44.74Z",
    transform: "translate(-8.75 -1.99)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M256.35,93.28l-2.66-7.09a45.71,45.71,0,0,0,4.78.25c2.48,0,3.87-1,4.17-3.14a2.45,2.45,0,0,0,0-.44q0-1.86-5.39-3.21t-5.44-6.2c0-1.6,0-2.89.1-3.87q.69-6.94,15-8.11l1.29,7.3h-.42c-4.7,0-7.2,1.22-7.48,3.66a1.56,1.56,0,0,0,0,.42q0,2.09,5.91,3t5.92,6.26v3.74Q272,92.82,256.35,93.28Z",
    transform: "translate(-8.75 -1.99)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M280,60.38l-3.11.66a10.17,10.17,0,0,0-.58,2.54,1,1,0,0,1,.4.76c0,.22-.35.57-1.06,1a3.49,3.49,0,0,1-1.39.71c-.46,0-.69-.35-.69-1.06a13.6,13.6,0,0,1,.45-3.5,14.79,14.79,0,0,0-1.63.12c-.69.08-1.17.12-1.42.12a5.21,5.21,0,0,1-1.41-.15,1.36,1.36,0,0,1-.78-.55,5.9,5.9,0,0,1-.47-1.24,4.76,4.76,0,0,1-.22-1.18,3.68,3.68,0,0,1,.41-1.19,13.55,13.55,0,0,1,1.25-2,15.07,15.07,0,0,1,1.91-2.18A23.69,23.69,0,0,1,274.42,51c1.09-.75,2.14-1.41,3.14-2s1.91-1,2.7-1.39a6.11,6.11,0,0,1,1.42-.55q.72,0,.72.81a3.76,3.76,0,0,1-.29.84,1.22,1.22,0,0,1,.47.8,3,3,0,0,1-.13.92,3.6,3.6,0,0,1-.36.77l-.53.82c-.42.67-.74,1.17-.95,1.49l-.86,1.33c-.36.56-.65,1-.88,1.45a14.37,14.37,0,0,0-.73,1.47c1.55-.26,2.41-.4,2.56-.4.45,0,.67.17.67.52A5.49,5.49,0,0,1,280,60.38Zm-4.71-2.08a26.87,26.87,0,0,1,2.45-4.23c.86-1.18,1.7-2.24,2.53-3.2a6.79,6.79,0,0,0,1.25-1.65.24.24,0,0,0-.09-.2.49.49,0,0,0-.25-.07,11.9,11.9,0,0,0-2.42,1.33q-2.24,1.42-3.81,2.65a18.62,18.62,0,0,0-2.79,2.67,14,14,0,0,0-2.05,3.14C272,58.62,273.73,58.48,275.27,58.3Z",
    transform: "translate(-8.75 -1.99)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M288,59.86c-1.43,1.89-2.51,3.24-3.25,4s-1.35,1.2-1.83,1.2a1.46,1.46,0,0,1-1-.47,3,3,0,0,1-.73-1.25,5.49,5.49,0,0,1-.26-1.69,4.8,4.8,0,0,1,.11-1.06,4.53,4.53,0,0,1,.42-1,10.52,10.52,0,0,1,.82-1.24c.34-.44.76-.94,1.25-1.5q.44-.53.75-.87a1.56,1.56,0,0,1,.59-.48,2.35,2.35,0,0,1,.93-.13,2.92,2.92,0,0,1,.9.13c.29.08.43.17.43.25a2.31,2.31,0,0,1-.43,1,10.3,10.3,0,0,1-1.41,1.69,19,19,0,0,1-2.23,2,4.62,4.62,0,0,0-.28,1.33q0,.63.48.63a1.26,1.26,0,0,0,.59-.3c.28-.2.74-.59,1.4-1.17L287,59.32a10.77,10.77,0,0,0,1.34-1.5q.76-1,1.23-1.5c.73-.77,1.23-1.27,1.49-1.5a1.19,1.19,0,0,1,.77-.34.49.49,0,0,1,.48.22,2.09,2.09,0,0,1,.13.9,1.75,1.75,0,0,1-.06.5,2.05,2.05,0,0,1-.25.49c-.12.21-.37.58-.74,1.12l-1.33,1.92a6.7,6.7,0,0,0-.72,1.29,2.9,2.9,0,0,0-.31,1c0,.52.2.77.6.77a2.36,2.36,0,0,0,1.17-.41c.44-.28,1.12-.77,2-1.49v1q-1.72,1.59-2.55,2.31a10.87,10.87,0,0,1-1.43,1.1,2.31,2.31,0,0,1-1.15.37c-.83,0-1.24-.5-1.24-1.48a4.39,4.39,0,0,1,.37-1.51C287.06,62,287.46,61.06,288,59.86Z",
    transform: "translate(-8.75 -1.99)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.45fbb0e12f40c5a80a6289e7231583e9.svg";
export { ForwardRef as ReactComponent };